module.exports = __webpack_public_path__ + "img/coupon_bg.8e7a0b7d.png";